import { request } from 'Apiv2/handleRequest';

export const fetchBlockApiWrapper = (requestProvider = request) => {
  return async (carePlanUuid, type) => {
    const ENDPOINT_URL = `/care_plans/${carePlanUuid}/blocks/${type}`;
    try {
      const response = await requestProvider(ENDPOINT_URL);
      const status = response.status;
      const data = await response.json();

      return { status, data };
    } catch (error) {
      return { status: 'error', error };
    }
  };
};

export default fetchBlockApiWrapper(request);
